import React, { useEffect, useMemo, useState } from 'react';
import { Heading, Box } from '@chakra-ui/react';
import { routePaths } from 'constants/routes';
import {
  ActivityItems,
  UserItems,
  ManagementItems,
  SolicitationItemAdmin,
  SolicitationDanielLaw,
  SolicitationsItemsClient,
} from 'constants/allfunctions';
import { RouteComponentProps, useHistory } from 'react-router';
import { checkPermission, getUserType } from 'utils/authentication';
import useEventBus from 'hooks/useEventBus';
import { colors } from 'theme/colors';
import { HeaderDefault, GridCardsDefault } from './components/';
import { getLoggedUser } from 'utils/storage';
import { getUserData } from 'services/getUserData';

export const AFunctions: React.FC<RouteComponentProps> = ({ history }) => {
  const History = useHistory();
  const path = History.location.pathname;
  localStorage.setItem('goBack', path);

  const [typeUser, setTypeUser] = useState<any>();

  const eventBus = useEventBus();
  useEffect(() => {
    eventBus.dispatchEvent('onChangeTitle', '');
  }, []);
  const userType = useMemo(() => getUserType(), []);

  const handleGetDataUserLogged = async () => {
    try {
      const idLogged = getLoggedUser().id;
      const userLogged = await getUserData(String(idLogged));
      const dataUserLogged = userLogged.data;
      setTypeUser(dataUserLogged.employeeDanielLaw);
    } catch {}
  };

  useEffect(() => {
    handleGetDataUserLogged();
  }, []);

  return (
    <Box>
      <Heading mb="1em" as="h1" isTruncated color={colors.brand.tertiary}>
        Funções do Sistema
      </Heading>

      <HeaderDefault
        titleAllCard="Avaliações e Recursos"
        text="Exibir todas as minhas avaliações e recursos"
        href={routePaths.myAvaliations}
      />

      <GridCardsDefault
        arrayFunctionItems={ActivityItems}
        history={history}
        location={undefined}
        match={undefined}
      />

      {checkPermission({ onlyAdmin: true }) ? (
        <>
          <HeaderDefault
            titleAllCard="Documentos e Consultas"
            text="Exibir todos os meus documentos e consultas"
            href={userType === 'client' ? routePaths.clientDemands : routePaths.demands}
          />

          <GridCardsDefault
            arrayFunctionItems={
              typeUser === 'DANIEL_LAW'
                ? SolicitationItemAdmin.concat(SolicitationDanielLaw)
                : SolicitationItemAdmin
            }
            history={history}
            location={undefined}
            match={undefined}
          />
        </>
      ) : (
        <>
          <HeaderDefault
            titleAllCard="Documentos e Consultas"
            text="Exibir todos os meus documentos e consultas"
            href={userType === 'client' ? routePaths.clientDemands : routePaths.demands}
          />

          <GridCardsDefault
            arrayFunctionItems={SolicitationsItemsClient}
            history={history}
            location={undefined}
            match={undefined}
          />
        </>
      )}
      <Heading as="h3" fontWeight={'bold'} fontSize="20px" mb={'1.2rem'}>
        Usuários
      </Heading>

      <GridCardsDefault
        arrayFunctionItems={typeUser === 'DANIEL_LAW' ? ManagementItems : [ManagementItems[0]]}
        history={history}
        location={undefined}
        match={undefined}
      />

      <Heading as="h3" fontWeight={'bold'} fontSize="20px" mb="1rem">
        Gerenciamento de Atividades
      </Heading>
      <GridCardsDefault
        arrayFunctionItems={UserItems}
        history={history}
        location={undefined}
        match={undefined}
      />
    </Box>
  );
};
